<nav class="navbar navbar--central navbar--static fixed-top">
  <div class="container-fluid">
    <div class="navbar-policy">
      <a href="javascript:;" (click)="clearSelection()" class="navbar-policy__back d-lg-none" [class.is-disabled]="backDisabled">
        <svg class="icon"><use xlink:href="#chevron-left"></use></svg>
      </a>

      <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
        <a>Messages</a>
      </div>

      <div class="navbar-policy__nav d-lg-none">
        <div class="navbar-policy__nav-current">Messages</div>
      </div>

      <div class="navbar-policy__chat dropdown dropdown--persist" id="chatDropdown">
        <a href="#" role="button" id="chatTrigger-modal" data-toggle="dropdown" data-display="static" title="Chat" aria-haspopup="true" aria-expanded="false">
          <svg class="icon"><use xlink:href="#help-Icon"></use></svg>
        </a>
        <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
          <div class="chat-info has-emergency">
            <div class="container">
              <div class="chat-info__avatar">
                <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="" />
              </div>
              <div class="chat-info__content pb-10">
                <h5>Hi 👋! How can we help?</h5>
              </div>
              <div class="chat-info__close dropdown-close">
                <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
              </div>
            </div>
            <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
              <div class="container">
                <div class="accordion__item">
                  <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                    <div class="accordion__title-text"><h6>Chat with a broker</h6></div>
                    <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg></div>
                  </a>
                  <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                    <div class="accordion__content">
                      <p class="mb-10">What can we assist with?</p>
                      <div class="form-group mb-15">
                        <select id="chat-select" class="ui-selectmenu" [(ngModel)]="chatSelectValue">
                          <option value="" selected>Please select</option>
                          <option value="1">Business insurance</option>
                          <option value="2">Professional insurance</option>
                          <option value="3">Personal insurance</option>
                          <option value="4">Lifestyle insurance</option>
                          <option value="5">Tourism insurance</option>
                          <option value="0">Other</option>
                        </select>
                      </div>
                      <div class="text-center">
                        <a href="#" id="start-chat-btn" class="button button--primary" [class.disabled]="!chatSelectValue">Start Chat</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion__item">
                  <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                    <div class="accordion__title-text"><h6>Call a broker</h6></div>
                    <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg></div>
                  </a>
                  <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                    <div class="accordion__content">
                      <p>Our licensed Everything.Insure brokers are ready to help you. Please get in touch.</p>
                      <p class="chat-info__accordion-call">
                        <svg class="icon icon--sm"><use xlink:href="#phone-filled"></use></svg>
                        <strong class="font-16">011 510 1300</strong>
                        <span>or</span>
                        <a href="#"><strong>Request a Call</strong></a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion__item">
                  <a href="#help-3" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                    <div class="accordion__title-text"><h6>We can create a quote for you</h6></div>
                    <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg></div>
                  </a>
                  <div class="accordion__body collapse" id="help-3" data-parent="#accordion-help">
                    <div class="accordion__content">
                      <span class="tag tag--sm tag--free mb-10">Free Service</span>
                      <p>Simply upload a Policy Schedule from a different Insurer and we'll use that to build a new quote for you!</p>
                      <p>
                        <a href="#" class="button-control button-control--tight">
                          <svg class="icon icon--sm"><use xlink:href="#upload"></use></svg><strong>Upload Schedule</strong>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-info__emergency">
            <a href="/pages/everything.login.html">
              <svg class="icon"><use xlink:href="#navigation-sos"></use></svg>
              Emergency services
            </a>
          </div>
        </div>
      </div>

      <a href="javascript:;" (click)="goBack()" class="navbar-policy__close">
        <svg class="icon"><use xlink:href="#close-medium"></use></svg>
      </a>
    </div>
  </div>
</nav>

<main class="page-main">

  <!-- Empty state -->
  @if (!hasNotifications && !showNewChat) {
    <div class="layout layout--notifications">
      <div class="layout__row">
        <div class="layout__bodycol">
          <div class="layout__bodycol-inner">
            <div class="card card--notifications is-active">
              <div class="card-body">
                <div class="card__empty">
                  <img src="assets/img/notifications-empty.svg" alt="" class="img-responsive" />
                  <p>You don't have any new notifications.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Notifications / new chat state -->
  @if (hasNotifications || showNewChat) {
    <div class="layout layout--notifications">
      <div class="layout__row">
        <!-- SIDEBAR -->
        <div class="layout__sidecol">
          <div class="layout__sidecol-inner" #sidecolInner (scroll)="onSidecolScroll()">
            <div class="notification-filters" #notifFilters>
              <div class="notification-filters__dd">
                <div class="dropdown dropdown--central dropdown--central-sm dropdown--persist">
                  <div class="input-wrap input-wrap--dropdown" data-toggle="dropdown">
                    <div class="input-wrap-prepend">
                      <div class="input-wrap-icon is-active">
                        <svg class="icon"><use xlink:href="#envelope"></use></svg>
                      </div>
                    </div>
                    <div class="form-control">{{ policyFilterLabel }}</div>
                    <div class="input-wrap-append">
                      <button class="input-wrap-icon">
                        <svg class="icon"><use xlink:href="#chevron-up-small"></use></svg>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu dropdown-menu--full-width filter-list__scrollable">
                    <div class="filter-list__content">
                      <div class="selection-filters">
                        <label class="selection">
                          <input type="checkbox" [(ngModel)]="policyFilterAll" (change)="onPolicyFilterAllChange()" name="selection-messages" value="all" />
                          <div class="selection__inner">
                            <div class="selection__main">
                              <div class="selection__content">
                                <div class="selection__indi"><span></span></div>
                                <div class="selection__label">
                                  <div class="selection__title">All messages</div>
                                </div>
                                <div class="selection__count">
                                  <span class="tag-pill tag-pill--num-outline">{{ allThreadCount }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        @for (pol of uniquePolicies; track pol) {
                          <label class="selection">
                            <input type="checkbox" [(ngModel)]="selectedPolicyIds[pol.policyId]" (change)="onPolicyFilterChange()" [name]="'selection-policy-' + pol.policyId" />
                            <div class="selection__inner">
                              <div class="selection__main">
                                <div class="selection__content">
                                  <div class="selection__indi"><span></span></div>
                                  <div class="selection__label">
                                    <div class="selection__title">{{ pol.label }}</div>
                                    @if (pol.subtitle) {
                                      <div class="selection__subtitle">{{ pol.subtitle }}</div>
                                    }
                                  </div>
                                  <div class="selection__count">
                                    <span class="tag-pill tag-pill--num-outline">{{ pol.count }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </label>
                        }
                      </div>
                    </div>
                    <div class="filter-list__button">
                      <a href="javascript:;" (click)="clearPolicyFilter()" class="button button--secondary dropdown-close">Cancel</a>
                      <a href="javascript:;" (click)="applyPolicyFilter()" class="button button--primary dropdown-close">Apply</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="notification-filters__wrap">
                <div class="notification-filters__search">
                  <div class="input-wrap">
                    <div class="input-wrap-prepend">
                      <div class="input-wrap-icon">
                        <svg class="icon"><use xlink:href="#search"></use></svg>
                      </div>
                    </div>
                    <input type="text" [(ngModel)]="searchQuery" placeholder="Search messages" class="form-control form-control--sm" />
                  </div>
                </div>
                <div class="notification-filters__categories">
                  <div class="notification-filters__categories-more">
                    <div class="dropdown dropdown--central dropdown--central-sm dropdown--persist">
                      <a href="#" data-toggle="dropdown" class="filter-button">
                        <svg class="icon"><use xlink:href="#filter"></use></svg>
                        @if (activeFilterCount > 0) {
                          <span class="counter-badge counter-badge--everything">{{ activeFilterCount }}</span>
                        }
                      </a>
                      <div class="dropdown-menu dropdown-menu-right filter-list__scrollable">
                        <div class="filter-list__content">
                          <div class="filter-list__heading">Categories</div>
                          <ul class="filter-list filter-list--central list-unstyled" id="cat-filter-list">
                            <li>
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [(ngModel)]="filterCategoryPolicies" value="policies" name="cat-filter[]" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Policies</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [(ngModel)]="filterCategoryQuotes" value="quotes" name="cat-filter[]" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Quotes</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [(ngModel)]="filterCategoryClaims" value="claims" name="cat-filter[]" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Claims</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [(ngModel)]="filterCategoryPromotions" value="promotions" name="cat-filter[]" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Promotions</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--checkbox">
                                <input type="checkbox" [(ngModel)]="filterCategoryChats" value="chats" name="cat-filter[]" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Chats</span>
                              </label>
                            </li>
                          </ul>
                          <div class="filter-list__heading">Priority</div>
                          <ul class="filter-list filter-list--central list-unstyled" id="status-filter-list">
                            @for (p of priorities; track p) {
                              <li>
                                <label class="custom-input custom-input--checkbox">
                                  <input type="checkbox" [(ngModel)]="filterPriorityIds[p.priority_id]" [name]="'priority-filter-' + p.priority_id" />
                                  <span class="custom-input__indi"></span>
                                  <span class="custom-input__label">{{ p.priority_name }}</span>
                                </label>
                              </li>
                            }
                          </ul>
                          <div class="filter-list__heading">Date</div>
                          <ul class="filter-list filter-list--central list-unstyled" id="date-filter-list">
                            <li>
                              <label class="custom-input custom-input--radio">
                                <input type="radio" [(ngModel)]="filterDateRange" value="all" name="date-filter" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">All time</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--radio">
                                <input type="radio" [(ngModel)]="filterDateRange" value="3m" name="date-filter" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Last 3 months</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--radio">
                                <input type="radio" [(ngModel)]="filterDateRange" value="6m" name="date-filter" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Last 6 months</span>
                              </label>
                            </li>
                            <li>
                              <label class="custom-input custom-input--radio">
                                <input type="radio" [(ngModel)]="filterDateRange" value="1y" name="date-filter" />
                                <span class="custom-input__indi"></span>
                                <span class="custom-input__label">Last year</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div class="filter-list__button">
                          <a href="javascript:;" class="button button--secondary dropdown-close">Cancel</a>
                          <a href="javascript:;" id="status-filter-apply" (click)="applyFilters()" class="button button--primary dropdown-close">Apply</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul class="notification-list list-unstyled" id="notifications-list">
              @for (group of filteredGroupsByThread; track trackByCategory($index, group)) {
                <li [class]="'notification-list__' + group.category">
                  <a [attr.href]="'#notifications-' + group.category"
                    class="notification-list__title"
                    [class.is-stuck]="stuckCategory === group.category"
                    [attr.data-category]="group.category"
                    data-toggle="collapse"
                    aria-expanded="true">
                    <span class="notification-list__title-icon" [class.is-active]="group.category === 'unread'">
                      <svg class="icon"><use xlink:href="#envelope-filled"></use></svg>
                    </span>
                    <p>{{ group.label }} <span class="counter-badge">{{ group.threads.length }}</span></p>
                    <svg class="icon"><use xlink:href="#chevron-right"></use></svg>
                  </a>
                  <!-- All threads — collapse toggled by the title above -->
                  <div class="notification-list__expander collapse show"
                    [id]="'notifications-' + group.category">
                    @for (thread of group.threads; track trackByThread($index, thread)) {
                      <div
                        class="notification-list__item"
                        [attr.data-item-id]="thread.preview.id"
                        [attr.data-item-category]="group.category"
                        [class.is-active]="currentThreadId === thread.threadId"
                        [class.is-read]="!thread.hasUnread"
                        (click)="selectNotification(thread.preview)">
                        <div class="notification-list__item-icon">
                          <svg class="icon icon--sm" [class.is-high]="thread.preview.priorityId && thread.preview.priorityId <= 2">
                            <use [attr.xlink:href]="'#' + thread.preview.icon"></use>
                          </svg>
                        </div>
                        <div class="notification-list__item-content">
                          <div class="notification-list__item-header">
                            <div class="notification-list__item-header-title">
                              <h6>{{ thread.conversationName || thread.preview.title }}</h6>
                              @if (thread.hasAttachment) {
                                <svg class="icon icon--xs"><use xlink:href="#attachment"></use></svg>
                              }
                            </div>
                            @if (thread.channels.length > 0) {
                              <div class="notification-list__item-header-via">
                                @for (ch of thread.channels.slice(0, 2); track ch) {
                                  <svg class="icon">
                                    <use [attr.xlink:href]="'#' + getChannelIcon(ch)"></use>
                                  </svg>
                                }
                                @if (thread.channels.length > 2) {
                                  <span class="icon">+{{ thread.channels.length - 2 }}</span>
                                }
                              </div>
                            }
                            <small class="notification-list__item-header-time">{{ thread.preview.displayDate }}</small>
                          </div>
                          @if (thread.preview.channelId !== 6) {
                            <p>{{ thread.conversationDescription || thread.preview.parsedMessage?.heading || thread.preview.plainText }}</p>
                          }
                          @if ((thread.preview.priorityId && thread.preview.priorityId <= 2) || thread.preview.parsedMessage?.days_left) {
                            <div class="notification-list__item-alerts">
                              @if (thread.preview.priorityId && thread.preview.priorityId <= 2) {
                                <span class="tag-pill tag-pill--warning">{{ thread.preview.priorityName }}</span>
                              }
                              @if (thread.preview.parsedMessage?.days_left) {
                                <span class="status status--attention float-right">
                                  {{ thread.preview.parsedMessage.days_left }} days left
                                  <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="">
                                    <svg class="icon"><use xlink:href="#help-Icon"></use></svg>
                                  </a>
                                </span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
        <!-- DETAIL PANEL -->
        <div class="layout__bodycol">
          <div class="layout__bodycol-inner">
            <!-- New conversation (no thread yet) -->
            @if (showNewChat && !currentThreadId) {
              <div class="card-notifications-wrap is-active">
                <div class="card card--notifications is-active">
                  <div class="card__title">
                    <h4>New Conversation</h4>
                  </div>
                  <div class="card-body chat-body chat-body--empty">
                    <p class="chat-empty-hint">Start your conversation below</p>
                  </div>
                  <div class="card__tray">
                    <div class="card__reply" [class.is-active]="replyActive" (click)="activateReply()">
                      <textarea class="form-control" [rows]="replyActive ? 3 : 1" placeholder="Write a reply..." [(ngModel)]="newChatMessage" (focus)="onReplyFocus()" (blur)="onReplyBlur()" (keydown)="onMessageKeydown($event)"></textarea>
                      <div class="card__reply-actions">
                        <div class="card__reply-actions-left">
                          <a href="#" data-target="#modal-upload" data-toggle="modal" class="icon-button icon-button--outline">
                            <svg class="icon"><use xlink:href="#attachment"></use></svg>
                          </a>
                          @if (pendingAttachmentUrl) {
                            <span class="tag tag--sm tag--success ml-5">1 file attached</span>
                          }
                        </div>
                        <div class="card__reply-actions-right">
                          <!-- <a href="javascript:;" (click)="sendMessage()" class="button button--md button--primary">Send</a> -->
                          <button type="button" class="icon-button icon-button--solid" title="Send" (click)="sendMessage()">
                            <svg class="icon"><use xlink:href="#send-solid"></use></svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="notification-cc">
                  <p>Also send to</p>
                  <div class="notification-cc__filters">
                    @for (ch of channels; track ch) {
                      <div class="notification-cc__filters-item">
                        <label class="selection">
                          <input type="checkbox" [(ngModel)]="notifyChannels[ch.id]" [name]="'notify-ch-' + ch.id">
                          <div class="selection__inner">
                            <div class="selection__main">
                              <div class="selection__content">
                                <div class="selection__indi"><span></span></div>
                                <div class="selection__label">
                                  <div class="selection__title">{{ ch.name }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- Mailchimp / email render (channel 6) -->
            @if (currentThreadId && isMailchimpThread) {
              <div class="card-notifications-wrap is-active">
                <div class="card card--notifications is-active">
                  <div class="card__title">
                    <h4>{{ selectedNotification?.title }}</h4>
                  </div>
                  <div class="card-body chat-body">
                    @for (dateGroup of selectedThreadMessagesByDate; track dateGroup) {
                      @for (msg of dateGroup.messages; track msg) {
                        <div [innerHTML]="msg.message"></div>
                      }
                    }
                  </div>
                </div>
              </div>
            }
            <!-- Regular thread view -->
            @if (currentThreadId && !isMailchimpThread) {
              <div class="card-notifications-wrap is-active">
                <div class="card card--notifications is-active">
                  <div class="card__title">
                    <h4>{{ selectedNotification?.title }}</h4>
                  </div>
                  <div #chatBody class="card-body">
                    <!-- Older date groups — hidden until expanded -->
                    <div class="card__expander collapse" [class.show]="showOlderMessages">
                      @for (dateGroup of olderThreadMessages; track trackByDate($index, dateGroup)) {
                        <div class="card__meta">
                          <small class="card__meta-time">{{ dateGroup.date }}</small>
                          @if (dateGroup.messages[0]?.parsedMessage?.days_left) {
                            <span class="card__meta-status status status--attention float-right">
                              {{ dateGroup.messages[0].parsedMessage.days_left }} days left
                              <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="">
                                <svg class="icon"><use xlink:href="#help-Icon"></use></svg>
                              </a>
                            </span>
                          }
                        </div>
                        @for (msg of dateGroup.messages; track trackByMessage($index, msg)) {
                          <div
                            class="card__item"
                            [class.card__item--outbound]="msg.direction === 'inbound'">
                            <div class="card__avatar">
                              @if (msg.direction === 'outbound') {
                                <img src="assets/img/avatar-confetti-happy@2x.png" class="img-fluid" alt="" />
                              }
                              @if (msg.direction === 'inbound') {
                                <svg class="icon icon--sm"><use xlink:href="#profile"></use></svg>
                              }
                            </div>
                            <div class="card__content">
                              @if (msg.parsedMessage) {
                                <div class="card__content-meta">
                                  <div class="card__content-meta-sender">
                                    <div class="card__content-meta-heading">
                                      @if (msg.sender) {
                                        <h5 class="font-16">{{ msg.sender }}</h5>
                                      }
                                      @if (msg.parsedMessage.heading) {
                                        <h4>{{ msg.parsedMessage.heading }}</h4>
                                      }
                                    </div>
                                    <div class="card__content-meta-via">
                                      @if (msg.channelId) {
                                        <svg class="icon">
                                          <use [attr.xlink:href]="'#' + getChannelIcon(msg.channelId)"></use>
                                        </svg>
                                      }
                                    </div>
                                  </div>
                                </div>
                                @if (msg.parsedMessage.text) {
                                  <p>{{ msg.parsedMessage.text }}</p>
                                }
                                @for (action of msg.parsedMessage.actions; track action) {
                                  <a
                                    [href]="buildActionUrl(action.url, msg.policyId)"
                                    [class]="'button ' + (action.primary ? 'button--primary' : 'button--secondary')">
                                    {{ action.label }}
                                  </a>
                                }
                              } @else {
                                <div class="card__content-meta">
                                  <div class="card__content-meta-sender">
                                    @if (msg.sender) {
                                      <h5 class="font-16">{{ msg.sender }}</h5>
                                    }
                                    @if (!msg.sender && msg.title) {
                                      <h4>{{ msg.title }}</h4>
                                    }
                                    <div class="card__content-meta-via">
                                      @if (msg.channelId) {
                                        <svg class="icon">
                                          <use [attr.xlink:href]="'#' + getChannelIcon(msg.channelId)"></use>
                                        </svg>
                                      }
                                    </div>
                                  </div>
                                  @if (msg.senderTitle) {
                                    <small class="card__content-meta-title">{{ msg.senderTitle }}</small>
                                  }
                                </div>
                                <p [innerHTML]="msg.message"></p>
                              }
                              @if (msg.attachmentUrl) {
                                <div class="card__content-attachments">
                                  <a href="javascript:;" (click)="openAttachment(msg.attachmentUrl, msg.attachmentName)">
                                    <svg class="icon icon--sm"><use xlink:href="#attachment"></use></svg>
                                    <span>{{ msg.attachmentName || 'Attachment' }}</span>
                                  </a>
                                </div>
                              }
                            </div>
                            <div class="card__extras">
                              @if (false) {
                                <div class="card__extras-dd">
                                  <div class="dropdown dropdown--central dropdown--central-sm dropdown--persist">
                                    <a href="#" data-toggle="dropdown" class="dropdown-button">
                                      <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                      <div class="profile-drop">
                                        <ul class="profile-drop__list list-unstyled">
                                          <li>
                                            <a href="javascript:;">
                                              <svg class="icon"><use xlink:href="#edit"></use></svg>
                                              <span>Edit</span>
                                            </a>
                                          </li>
                                          <li>
                                            <a href="javascript:;" (click)="activateReply()">
                                              <svg class="icon icon--flip"><use xlink:href="#reply"></use></svg>
                                              <span>Reply</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              <small class="card__extras-time">{{ msg.displayTime }}</small>
                            </div>
                          </div>
                        }
                      }
                    </div>
                    <!-- Most recent date group — always visible -->
                    @for (dateGroup of recentThreadMessages; track trackByDate($index, dateGroup)) {
                      @if (dateGroup.date) {
                        <div class="card__meta">
                          <small class="card__meta-time">{{ dateGroup.date }}</small>
                          @if (dateGroup.messages[0]?.parsedMessage?.days_left) {
                            <span class="card__meta-status status status--attention float-right">
                              {{ dateGroup.messages[0].parsedMessage.days_left }} days left
                              <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-content="">
                                <svg class="icon"><use xlink:href="#help-Icon"></use></svg>
                              </a>
                            </span>
                          }
                        </div>
                      }
                      @for (msg of dateGroup.messages; track trackByMessage($index, msg)) {
                        <div
                          class="card__item"
                          [class.card__item--outbound]="msg.direction === 'inbound'">
                          <div class="card__avatar">
                            @if (msg.direction === 'outbound') {
                              <img src="assets/img/avatar-confetti-happy@2x.png" class="img-fluid" alt="" />
                            }
                            @if (msg.direction === 'inbound') {
                              <svg class="icon icon--sm"><use xlink:href="#profile"></use></svg>
                            }
                          </div>
                          <div class="card__content">
                            @if (msg.parsedMessage) {
                              <div class="card__content-meta">
                                <div class="card__content-meta-sender">
                                  <div class="card__content-meta-heading">
                                    @if (msg.sender) {
                                      <h5 class="font-16">{{ msg.sender }}</h5>
                                    }
                                    @if (msg.parsedMessage.heading) {
                                      <h4>{{ msg.parsedMessage.heading }}</h4>
                                    }
                                  </div>
                                  <div class="card__content-meta-via">
                                    @if (msg.channelId) {
                                      <svg class="icon">
                                        <use [attr.xlink:href]="'#' + getChannelIcon(msg.channelId)"></use>
                                      </svg>
                                    }
                                  </div>
                                </div>
                              </div>
                              @if (msg.parsedMessage.text) {
                                <p>{{ msg.parsedMessage.text }}</p>
                              }
                              @for (action of msg.parsedMessage.actions; track action) {
                                <a
                                  [href]="buildActionUrl(action.url, msg.policyId)"
                                  [class]="'button ' + (action.primary ? 'button--primary' : 'button--secondary')">
                                  {{ action.label }}
                                </a>
                              }
                            } @else {
                              <div class="card__content-meta">
                                <div class="card__content-meta-sender">
                                  @if (msg.sender) {
                                    <h5 class="font-16">{{ msg.sender }}</h5>
                                  }
                                  @if (!msg.sender && msg.title) {
                                    <h4>{{ msg.title }}</h4>
                                  }
                                  <div class="card__content-meta-via">
                                    @if (msg.channelId) {
                                      <svg class="icon">
                                        <use [attr.xlink:href]="'#' + getChannelIcon(msg.channelId)"></use>
                                      </svg>
                                    }
                                  </div>
                                </div>
                                @if (msg.senderTitle) {
                                  <small class="card__content-meta-title">{{ msg.senderTitle }}</small>
                                }
                              </div>
                              <p [innerHTML]="msg.message"></p>
                            }
                            @if (msg.attachmentUrl) {
                              <div class="card__content-attachments">
                                <a href="javascript:;" (click)="openAttachment(msg.attachmentUrl, msg.attachmentName)">
                                  <svg class="icon icon--sm"><use xlink:href="#attachment"></use></svg>
                                  <span>{{ msg.attachmentName || 'Attachment' }}</span>
                                </a>
                              </div>
                            }
                          </div>
                          <div class="card__extras">
                            @if (false) {
                              <div class="card__extras-dd">
                                <div class="dropdown dropdown--central dropdown--central-sm dropdown--persist">
                                  <a href="#" data-toggle="dropdown" class="dropdown-button">
                                    <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right">
                                    <div class="profile-drop">
                                      <ul class="profile-drop__list list-unstyled">
                                        <li>
                                          <a href="javascript:;">
                                            <svg class="icon"><use xlink:href="#edit"></use></svg>
                                            <span>Edit</span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="javascript:;" (click)="activateReply()">
                                            <svg class="icon icon--flip"><use xlink:href="#reply"></use></svg>
                                            <span>Reply</span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            <small class="card__extras-time">{{ msg.displayTime }}</small>
                          </div>
                        </div>
                      }
                    }
                  </div>
                  <div class="card__tray">
                    @if (olderThreadMessages.length > 0 && !showOlderMessages) {
                      <a
                        href="javascript:;"
                        (click)="showOlderMessages = true"
                        aria-expanded="false"
                        class="card__prev collapsed">
                        Show previous notifications (<span>{{ olderThreadMessages.length }}</span>)
                      </a>
                    }
                    @if (!selectedNotification?.parsedMessage) {
                      <div class="card__reply" [class.is-active]="replyActive" (click)="activateReply()">
                        <textarea class="form-control" [rows]="replyActive ? 3 : 1" placeholder="Write a reply..." [(ngModel)]="newChatMessage" (focus)="onReplyFocus()" (blur)="onReplyBlur()" (keydown)="onMessageKeydown($event)"></textarea>
                        <div class="card__reply-actions">
                          <div class="card__reply-actions-left">
                            <a href="#" data-target="#modal-upload" data-toggle="modal" class="icon-button icon-button--outline">
                              <svg class="icon"><use xlink:href="#attachment"></use></svg>
                            </a>
                            @if (pendingAttachmentUrl) {
                              <span class="tag tag--sm tag--success ml-5">1 file attached</span>
                            }
                          </div>
                          <div class="card__reply-actions-right">
                            <!-- <a href="javascript:;" (click)="sendMessage()" class="button button--md button--primary">Send</a> -->
                            <button type="button" class="icon-button icon-button--solid" title="Send" (click)="sendMessage()">
                              <svg class="icon"><use xlink:href="#send-solid"></use></svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                @if (!selectedNotification?.parsedMessage) {
                  <div class="notification-cc">
                    <p>Also send to</p>
                    <div class="notification-cc__filters">
                      @for (ch of channels; track ch) {
                        <div class="notification-cc__filters-item">
                          <label class="selection">
                            <input type="checkbox" [(ngModel)]="notifyChannels[ch.id]" [name]="'notify-ch-' + ch.id">
                            <div class="selection__inner">
                              <div class="selection__main">
                                <div class="selection__content">
                                  <div class="selection__indi"><span></span></div>
                                  <div class="selection__label">
                                    <div class="selection__title">{{ ch.name }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

</main>

<!-- Floating new chat button -->
@if (false) {
  <div class="notification-chat" style="z-index: 20">
    <a href="javascript:;" (click)="startNewChat()"
      class="button button--lg button--floating button--primary d-sm-none"
      [class.d-none]="!!(selectedNotificationId || showNewChat || currentThreadId)"
      id="chat-btn-mobile">
      <svg class="icon icon--md"><use xlink:href="#chat"></use></svg>
    </a>
    <a href="javascript:;" (click)="startNewChat()"
      class="button button--lg button--primary button--shadow d-none d-sm-inline-flex"
      id="chat-btn-desktop">
      <span>New Chat</span>
      <svg class="icon"><use xlink:href="#chat"></use></svg>
    </a>
  </div>
}

<!-- Mobile filter tray -->
<div class="modal fade modal--tray" id="modal-traymenu-filters" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-filters" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">
      <div class="modal-traymenu__header">
        <div class="container">
          <h6>Filters</h6>
          <a href="javascript:;" (click)="clearFilters()" class="modal-traymenu__header-clear">Clear</a>
          <a href="#" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </div>
      <div class="modal-traymenu__filters">
        <div class="container">
          <div class="filter-list__heading">Type</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-products-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" [(ngModel)]="filterType" value="all" name="mobile-notifications-type-filter" />
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" [(ngModel)]="filterType" value="unread" name="mobile-notifications-type-filter" />
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Unread</span>
              </label>
            </li>
          </ul>
          <div class="filter-list__heading">Priority</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-status-filter-list">
            @for (p of priorities; track p) {
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox" [(ngModel)]="filterPriorityIds[p.priority_id]" [name]="'mobile-priority-filter-' + p.priority_id" />
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">{{ p.priority_name }}</span>
                </label>
              </li>
            }
          </ul>
        </div>
      </div>
      <div class="modal-traymenu__btn">
        <div class="container">
          <a href="javascript:;" id="mobile-status-filter-apply" data-dismiss="modal" (click)="applyFilters()" class="button button--primary button--block">Apply</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Upload attachment modal -->
<div class="modal fade modal--mini" id="modal-upload" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Upload attachment</h4>
          <button class="modal-mini__heading-close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>
      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="form-group form-group--sm">
            <div class="custom-upload dz-clickable custom-upload--docs" id="notification-dropzone">
              <div class="custom-upload__dropzone dz-default">
                <div class="custom-upload__thumb">
                  <img src="/assets/img/upload-documents.svg" />
                </div>
                <div class="custom-upload__instructions">
                  <p>Tap to add files</p>
                  <svg class="icon"><use xlink:href="#upload"></use></svg>
                  <p>Drag &amp; drop files here or <strong>browse</strong></p>
                </div>
              </div>
              <div class="fallback">
                <input type="file" name="file" multiple />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" data-dismiss="modal" class="button button--secondary">Cancel</a>
          <a href="#" data-dismiss="modal" class="button button--primary" [class.disabled]="!pendingAttachmentUrl">Submit</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile: Notify via channels -->
<div class="modal fade modal--tray" id="modal-notification-filters" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list">
          <ul class="filter-list list-unstyled">
            @for (ch of channels; track ch) {
              <li>
                <label class="custom-input custom-input--checkbox">
                  <input type="checkbox" [(ngModel)]="notifyChannels[ch.id]" [name]="'mobile-notify-ch-' + ch.id" />
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">{{ ch.name }}</span>
                </label>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Attachment viewer modal -->
<div class="modal fade modal--fs" id="attachment-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-header">
        <div class="container-fluid">
          <div class="modal-nav">
            <div class="modal-nav__title">
              <h6>{{ attachmentTitle }}</h6>
            </div>
            <div class="modal-nav__actions">
              <button class="button-control button-control--grey" data-dismiss="modal" (click)="closeAttachment()"><strong>Close</strong></button>
            </div>
          </div>
        </div>
      </header>
      <div class="modal-body">
        <div class="container">
          @if (viewingAttachmentUrl) {
            <iframe [src]="viewingAttachmentUrl | safeUrl" width="100%" height="100%" style="border:none; min-height:80vh;"></iframe>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<app-disclaimer></app-disclaimer>
